//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('UsersService', [
    '$log',
    'CoreApiService',
    'rx',
    'USERS_ACTIONS',
    function(
            $log,
            CoreApiService,
            rx,
            USERS_ACTIONS,
        ) {
      const initialState = {
        users: [],
      };

      const updates = new rx.ReplaySubject(1);
      const usersState = updates.scan((state, action) => {
        const newState = angular.copy(state);
        switch (action.type) {
          case USERS_ACTIONS.REFRESH_USERS:
            newState.users = action.users;
            break;
          default:
            $log.error(`unrecognized action type: ${action.type}`);
            break;
        }
        return newState;
      }, initialState);

      this.getUsersState = function() {
        return usersState.asObservable();
      };

      this.refresh = function() {
        rx.Observable.fromPromise(CoreApiService.getUsersAsync()).subscribe((response) => {
          updates.next({
            type: USERS_ACTIONS.REFRESH_USERS,
            users: response,
          });
        });
      };

            // initialize the service
      this.refresh();
    },
  ]);
})();
